import * as React from "react";
import {CIRole} from "./Role";

function RoleIcon({fill="currentColor"}) {
  return <CIRole fill={fill} />;
}

export default RoleIcon;